import {IconBox, IconProps} from "../index";
import React from "react";

import GoogleSvg from "../../../../assets/icons/login/google.svg?react";

export const GoogleIcon = (props: IconProps) => {
    return (
        <IconBox {...props}>
            <GoogleSvg/>
        </IconBox>
    );
}
